var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"character-avatar-item"},[_c('div',{staticClass:"avatar"},[_c('head-image',{attrs:{"url":_vm.characterAvatar.avatar,"name":_vm.characterAvatar.name}})],1),_c('div',{staticClass:"text"},[_c('div',[_vm._v(_vm._s(_vm.characterAvatar.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }